module.exports = __webpack_public_path__ + "img/driving.a803792c.png";